"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var pinterest = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 793 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", d: "M338 3c-83 10-166 49-228 107C43 174 4 259 0 348c-5 137 44 214 148 237l14 3 7-12c35-63 15-96-3-126-8-14-16-27-19-44-17-102 38-202 139-253 96-49 202-35 270 34 56 56 72 206 9 322-20 37-64 96-137 82-20-5-34-12-41-24-17-30 1-87 19-143 24-77 55-174-29-208-46-18-89-7-122 32-47 56-59 155-26 219-8 38-18 76-28 115-32 117-64 238-43 387l4 31 26-18c91-66 123-186 147-305 2 1 5 3 7 4 29 21 57 40 105 44 86 6 162-23 222-87 81-86 120-223 101-358C745 94 563-22 338 3z" })));
};
pinterest.displayName = 'pinterest';
exports.default = pinterest;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=pinterest.js.map